import { apiInstance } from 'utils/request'
import parseError from 'helpers/parseServerError'

export const getArcAdvertisers = ({ page, search, filters, sorter }) => {
  return apiInstance
    .get('/arc_advertisers', {
      params: {
        filter: {
          search: search ? encodeURIComponent(search) : null,
          ...filters,
        },
        sort: sorter || 'id',
        page: {
          number: page,
          size: 20,
        },
      },
      headers: {
        'Accept': 'application/vnd.api+json',
      },
    })
    .catch((error) => {
      parseError(error, 'Cannot get arc advertisers')
    })
}

export const getArcAdvertiser = (id) => {
  return apiInstance
    .get(`/arc_advertisers/${id}`, {
      headers: {
        'Accept': 'application/vnd.api+json',
      },
    })
    .catch((error) => {
      parseError(error, 'Cannot get arc advertiser')
    })
}

export const createArcAdvertiser = (data) => {
  return apiInstance
    .post('/arc_advertisers', {
      data,
    }, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "Arc advertiser hasn't been created")
    })
}

export const updateArcAdvertiser = (data) => {
  return apiInstance
    .put(`/arc_advertisers/${data.id}`, {
      data,
    }, {
      headers: {
        'Content-Type': 'application/vnd.api+json',
      },
    })
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "Arc advertiser hasn't been updated")
    })
}

export const deleteArcAdvertiser = (id) =>
  apiInstance
    .delete(`/arc_advertisers/${id}`)
    .then(() => ({ data: 'OK' }))
    .catch((error) => {
      parseError(error, "Arc advertiser hasn't been deleted")
    })